export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";